var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { css, styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { createA11yOutlineStyles } from '../helpers/a11y';
const StyledReferenceBadge = styled.button.withConfig({ displayName: "StyledReferenceBadge", componentId: "sc-q385m9" }) `position:relative;background:none;border-radius:100px;border:0;cursor:pointer;display:inline;font-weight:initial;line-height:1;margin:0;padding:0;white-space:nowrap;${({ theme, variant }) => variant === 'default' &&
    css `
			min-width: 1.25em;
			padding: 0.125em 0.35em;
			font-size: ${theme.fonts.label[100].fontSize};

			&::before {
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: ${({ theme }) => theme.size.static350};
				height: ${({ theme }) => theme.size.static350};
			}
		`} ${({ theme, variant }) => variant === 'large' &&
    css `
			min-width: 1.5em;
			padding: 0.25em 0.45em;
			font-size: ${theme.fonts.label[150].fontSize};
		`} color:${({ theme }) => theme.colors.content.primary};background:${({ theme }) => theme.colors.badge.default};box-shadow:inset 0 0 0 1px ${({ theme }) => theme.colors.border.default};&:hover,&:active{color:${({ theme }) => theme.colors.content.onsurface};background:${({ theme }) => theme.colors.badge.active};outline:0;box-shadow:inset 0 0 0 1px ${({ theme }) => theme.colors.badge.active};}&:focus:not(:focus-visible){box-shadow:inset 0 0 0 1px ${({ theme }) => theme.colors.badge.active};background:${({ theme }) => theme.colors.badge.active};color:${({ theme }) => theme.colors.content.onsurface};outline:none;}&:focus-visible{${({ theme }) => createA11yOutlineStyles(theme)}}`;
export const ReferenceBadge = React.forwardRef((props, forwardRef) => {
    const { children, onClick, variant = 'default' } = props, rest = __rest(props, ["children", "onClick", "variant"]);
    const commonProps = getCommonProps(props);
    const handleClick = React.useCallback((event) => {
        event.preventDefault();
        onClick && onClick(event);
    }, [onClick]);
    return (React.createElement(StyledReferenceBadge, Object.assign({ onClick: handleClick, ref: forwardRef, variant: variant }, commonProps, rest), children));
});
ReferenceBadge.displayName = 'ReferenceBadge';
export const DisclaimerReferenceBadge = React.forwardRef((props, forwardRef) => {
    const { children, onClick, variant = 'default' } = props, rest = __rest(props, ["children", "onClick", "variant"]);
    const commonProps = getCommonProps(props);
    const handleClick = React.useCallback((event) => {
        event.preventDefault();
        onClick && onClick(event);
    }, [onClick]);
    return (React.createElement(StyledReferenceBadge, Object.assign({ onClick: handleClick, ref: forwardRef, variant: variant, "data-component": "disclaimer-reference-badge" }, commonProps, rest), children));
});
DisclaimerReferenceBadge.displayName = 'DisclaimerReferenceBadge';
